import * as React from 'react';
import { cn } from '@frontend/shadcn/lib/utils';
import { SocialStatsIcon } from '@/applications/Social/components/icons/social-stats-icon';

const PerformanceHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex justify-between items-center mr-2', className)} {...props} />
  ),
);
PerformanceHeader.displayName = 'PerformanceHeader';

interface PerformanceTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  icon?: React.ComponentType<{ className?: string }>;
  iconBackgroundColor?: string;
}

const PerformanceTitle = React.forwardRef<HTMLHeadingElement, PerformanceTitleProps>(
  ({ className, children, icon, iconBackgroundColor, ...props }, ref) => {
    const IconComponent = icon || SocialStatsIcon;

    return (
      <h3 ref={ref} className={cn('text-sm font-medium mb-0 flex items-center gap-2', className)} {...props}>
        <div
          className="w-5 h-5 p-1 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: iconBackgroundColor || '#6c77de' }}
        >
          <IconComponent className="w-3 h-3" />
        </div>
        <span>{children}</span>
      </h3>
    );
  },
);
PerformanceTitle.displayName = 'PerformanceTitle';

const PerformanceDateRange = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('relative text-sm text-gray-600', className)} {...props} />
  ),
);
PerformanceDateRange.displayName = 'PerformanceDateRange';

export { PerformanceHeader, PerformanceTitle, PerformanceDateRange };
